import { CardMenu } from '@halo/ui-chat-react';

export function SpeakerOperate({
  value,
  children,
  onClick,
  items,
  container,
}: {
  children: React.ReactNode;
  onClick: (value: string) => void;
  value?: string;
  items: Array<{ key: string; label: React.ReactNode; disabled?: boolean }> | undefined;
  container?: React.RefObject<HTMLDivElement | null>;
}) {
  return (
    <CardMenu
      value={value}
      onClick={onClick}
      data={items || []}
      placement="top"
      itemProps={{
        justifyContent: 'center',
      }}
      container={container}
    >
      {children}
    </CardMenu>
  );
}

export default SpeakerOperate;
